import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const Section = styled.section`
   margin-top: 119px;
`;
